export * from './badge-status-painel-de-atendimento.pipe';
